import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, createVNode as _createVNode, mergeProps as _mergeProps, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-b7dcb03a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contentHeader flex" }
const _hoisted_2 = {
  key: 0,
  class: "contentBox"
}
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "smallIcon icon-pfeil-links iconInButton" }, null, -1))
const _hoisted_6 = { class: "text-grey ml-2 mt-1.5" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "flex" }
const _hoisted_9 = { class: "providerDetailBox" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = { class: "providerDetailBox" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = ["href"]
const _hoisted_17 = { class: "providerDetailBox" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_19 = { class: "showDetails" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "smallIcon icon-pfeil-hoch" }, null, -1))
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { class: "showDetails" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "smallIcon icon-pfeil-runter" }, null, -1))
const _hoisted_24 = {
  key: 0,
  class: "companyHasAdminNotification mb-2"
}
const _hoisted_25 = { class: "block w-full" }
const _hoisted_26 = { class: "flex mb-4" }
const _hoisted_27 = ["disabled", "title"]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-neu" }, null, -1))
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = ["disabled", "title"]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-loeschen" }, null, -1))
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = { class: "ml-auto" }
const _hoisted_34 = { class: "text-center" }

import {useSystemStore} from "@/stores/system/SystemStore";
import {BryntumGrid} from "@bryntum/grid-vue-3";
import GridInputFilter from "@/components/system/GridInputFilter.vue";
import {Grid, Menu, Store, StringHelper} from "@bryntum/grid";
import {onBeforeUnmount, onMounted, reactive, ref, watchEffect} from "vue";
import {useI18n} from "vue-i18n";
import {ProviderWorkerService} from "@/utilities/services/entities/ProviderWorkerService";
import {ProviderService} from "@/utilities/services/entities/ProviderService";
import {checkboxColumnConfig, defaultSpaceAroundTableOnPage} from "@/AppConfig";
import dialog from "@/components/system/dialog";
import {ErrorLocationType, PopupType, TableType} from "@/utilities/system/enums/Enums";
import NullOrUndefinedHelper from "@/utilities/system/helpers/NullOrUndefinedHelper";
import {ProviderWorker} from "@/models/entities/providerWorkers/ProviderWorker";
import router from "@/router";
import Error from "@/components/system/Error.vue";
import {Provider} from "@/models/entities/providers/Provider";
import LoadingSpinner from "@/components/system/LoadingSpinner.vue";



export default /*#__PURE__*/_defineComponent({
  __name: 'ProviderDetails',
  setup(__props) {

const gridStore = new Store();
const systemStore = useSystemStore();

let showProviderDetails = ref<boolean>(false);
let selectedProviderWorkers = ref<Array<ProviderWorker>>([]);
const selectedProvider = ref<Provider|undefined>(undefined);
const companyHasAdmin = ref<boolean>(false);

const { t } = useI18n();
const providerWorkerService = new ProviderWorkerService();
const providerService = new ProviderService();

const currentWindowHeight = ref("");
const recalcGridHeight = (offset: number = 110) => {
  currentWindowHeight.value = `${window.innerHeight-defaultSpaceAroundTableOnPage-offset}px`;
};

watchEffect(()=>{
  if (showProviderDetails.value) recalcGridHeight(195)
  else recalcGridHeight()
})

const deleteSelection = async() => {
  //drop call without selection
  if(!selectedProviderWorkers.value?.some(()=>true)) return;

  const answer = await dialog
      .okText(t("global.delete"))
      .cancelText(t("global.cancel"))
      .confirm(t("providerManagementDetails.confirmDeletionMulti", { count:selectedProviderWorkers.value.length}));

  if (answer) {
    let someEntriesFailed = false;
    for (const cw of selectedProviderWorkers.value){
      const resp = await providerWorkerService.deleteProviderWorker(selectedProvider.value?.id!, cw.id, ErrorLocationType.table);
      if(!resp){
        someEntriesFailed = true;
        continue;
      }

      gridStore.applyChangeset({removed:[{id:cw.id}]});
    }

    if (someEntriesFailed) return;

    systemStore.showSuccess(t("global.deleted"));
  }
};

const grid = ref<{instance:{value:Grid}}|null>(null);
const useGridConfig = {
  headerMenuFeature: false,
  relayStoreEvents: true,
  cellTooltipFeature: {
    hoverDelay      : 300,
    textContent     : true,
    hideOnDelegateChange: true,
  },
  enableTextSelection: false,
  selectionMode : {
    row	  : true,
    checkbox: checkboxColumnConfig,
    showCheckAll : true,
    deselectFilteredOutRecords: true
  },
  columns : {
    data: [
      {
        id:'firstName',
        field: 'firstName',
        text: t('providerManagementDetails.grid.name'),
        flex: 1,
        type: 'template',
        template: ({record}:any)=>{
          return StringHelper.xss`${record.data.firstName ?? ""} ${record.data.lastName ?? ""}`;
        }
      },
      {
        id:'isAdmin',
        field: 'isAdmin',
        text: t('providerManagementDetails.grid.admin'),
        width: 100,
        type: "template",
        template: ({record}:any) => {
          return record.data.isAdmin ? `<span class='adminBox'>Admin</span>` : "";
        },
      },
      {
        id:'email',
        field: 'email',
        text: t('providerManagementDetails.grid.email'),
        flex: 1
      },
      {
        id:'phoneNumber',
        field: 'phoneNumber',
        text: t('providerManagementDetails.grid.phoneNumber'),
        flex: 1,
        type: 'template',
        template: ({record}:any)=>{
          return StringHelper.xss`${record.data.dialCode ?? ""}${record.data.phoneNumber ?? ""}`;
        }
      },
      {
        id:'anAbSystem.userConfirmationExpired',
        field: 'anAbSystem.userConfirmationExpired',
        text:  t('providerManagementDetails.grid.active'),
        width   : 36,
        type: "template",
        template: ({record}:any) => {
          return record.data.anAbSystem?.userConfirmationExpired
              ? `<span class='icon-status_bald_inaktiv text-red biggerGridIcon'></span>`
              : `<span class='icon-status_aktiv text-green biggerGridIcon'></span>`;
        },
      },
      {
        id: 'info',
        field: 'info',
        text: "",
        width: 60,
        sortable: false,
        resizable: false,
        minWidth: 60,
        type: "template",
        tooltipRenderer: ({record}:any) => {
          return StringHelper.xss`${record.data.userInfo ?? ""}`
        },
        template: ({record}:any) => {
          if(!NullOrUndefinedHelper(record.data.userInfo)) {
            return `<div class="gridTooltipButton"><span class="icon-info text-blue"></span></div>`;
          }
        },
      },
      {
        id:'menu',
        text	: '',
        width   : 36,
        type	: 'widget',
        align: "center",
        hideable: false,
        resizable: false,
        sortable: false,
        filterable: false,
        widgets : [{
          type	 : 'button',
          width: 36,
          icon	 : 'icon-kontext_horizontal',
          onAction : ({ source: btn }:any) => {
            const menu = menuFactory(btn.cellInfo.record.data);
            menu.alignTo({ target: btn })
            menu.show();
          }
        }]
      },
    ],
    listeners:{
      async add(event:any){
        if(event.records.length === 1 && event.isMove[event.records[0].id]){
          await systemStore.saveUserColumnOrder(TableType[TableType.providerWorkers], event.records[0].id, event.index.toString());
        }
      },
    }
  },
  store: gridStore,
  listeners: {
    selectionChange(event:any) {
      if(event.selection.length > 0 && event.selection[0]?.data === undefined) return;
      selectedProviderWorkers.value = selectedProviderWorkers.value.concat(event.selected.map((cwr:any) => cwr.data))
      selectedProviderWorkers.value = selectedProviderWorkers.value.filter(cw => !event.deselected.map((cwr:any) => cwr.data).some((cwr:any) => cw?.id === cwr?.id));
    },
    datachange(){
      systemStore.currentItems = gridStore.count;
      systemStore.allItems = gridStore.getCount();
    },
    async cellClick({column, record}:any) {
      if (column.data.field === 'anAbSystem.userConfirmationExpired') {
        if(record.data.anAbSystem.userConfirmationExpired){
          const resp = await providerWorkerService.postResetExpirationForProviderWorker(selectedProvider.value?.id!, record.data.userId, ErrorLocationType.table); //TODO recheck workings
          record.data.anAbSystem.userConfirmationExpired = resp === null || resp === undefined || resp.statusCode !== 0;
          gridStore.add(record);
        }
      }
      if(column.data.field === 'isEnabled'){
        record.data.isEnabled = !record.data.isEnabled;
        const resp = await providerWorkerService.postSetProviderWorkerEnabled(record.data.userId, record.data.isEnabled, ErrorLocationType.table); //TODO recheck workings
        record.data.isEnabled = resp === null || resp === undefined || resp.statusCode !== 0;
        gridStore.add(record);
      }
    },
  },
  height: currentWindowHeight,
}
const gridConfig = reactive(useGridConfig);

const menuFactory = (record:any) => {
  const menu = new Menu({
    anchor   : true,
    autoShow : true,
    items	: [
      {
        text: t("providerManagementDetails.grid.reactivate"),
        disabled: !(record.anAbSystem === null && record.anAbSystem === undefined) || !record.anAbSystem?.userConfirmationExpired,
        cls: 'color',
        icon: 'icon-person',
        weight: 100,
        onItem : async ({record}:any) => {
          const resp = await providerWorkerService.postResetExpirationForProviderWorker(selectedProvider.value?.id!, record.data.userId, ErrorLocationType.table); //TODO recheck workings
          record.data.anAbSystem.userConfirmationExpired = resp === null || resp === undefined || resp.statusCode !== 0;
          gridStore.add(record);
        }
      },
      {
        text: t("global.edit"),
        disabled: selectedProvider.value?.hasAdmin,
        cls: 'color',
        icon: 'icon-editieren',
        weight: 100,
        onItem : ({ menu }:any) => {
          systemStore.openPopup({
            data: menu.record,
            action:addOrUpdateCompanyWorker,
            resetButton:false,
            title:t("providerManagementDetails.popups.edit.title"),
            type:PopupType.providerProviderWorkerEditPopup
          });
        }
      },
      {
        text   : t("global.delete"),
        hidden: false,
        cls	: 'color',
        icon: 'icon-loeschen',
        weight : 140,
        onItem: async ({ menu }:any) => {
          const answer = await dialog
              .okText(t("global.delete"))
              .cancelText(t("global.cancel"))
              .confirm(t("providerManagementDetails.confirmDeletionSingle", {name: `${menu.record.firstName} ${menu.record.lastName}`}));

          if (answer) {
            const resp = await providerWorkerService.deleteProviderWorker(selectedProvider.value?.id!, menu.record.id ?? menu.record.userId, ErrorLocationType.table);
            if(!resp) return

            gridStore.applyChangeset({removed:[{id:menu.record.id}]});

            systemStore.showSuccess(t('global.deleted'));
          }
        }
      }
    ],
  });

  //@ts-expect-error
  menu.setRecord(record);

  return menu;
};

const newCompanyWorker = () => {
  if (companyHasAdmin.value) return;

  systemStore.openPopup({
    data: new ProviderWorker(),
    action: checkForExistingPhoneNumber,
    resetButton: false,
    title:t("providerManagementDetails.popups.new.title"),
    type:PopupType.providerNewProviderWorkerPopup
  });
}

// CAUTION: missing userInfo prop here to show messages from api and clearing it before proceeding to edit new provider worker
const checkForExistingPhoneNumber = async ()=>{
  //@ts-expect-error
  systemStore.modal.contentObject.userInfo = "";

  const companyWorker = systemStore.modal.contentObject as ProviderWorker;

  const foundCompanyWorkerResp = await providerWorkerService.postSearchProviderWorkerByPhonenumber(selectedProvider.value?.id!, companyWorker.dialCode, companyWorker.phoneNumber, ErrorLocationType.popup);
  if(!foundCompanyWorkerResp) return

  if (foundCompanyWorkerResp.statusDescription !== ""){
    if(!NullOrUndefinedHelper(foundCompanyWorkerResp.user)){
      //@ts-expect-error
      foundCompanyWorkerResp.user.id = foundCompanyWorkerResp.user?.userId;
      gridStore.add(foundCompanyWorkerResp.user!);

      systemStore.closeModal()
      systemStore.showSuccess(t('providerManagementDetails.connectedWorker'))
    }
    return;
  }

  //@ts-expect-error
  systemStore.modal.contentObject.userInfo = "";
  const user = systemStore.modal.contentObject;

  systemStore.openPopup({
    data: user,
    action: addOrUpdateCompanyWorker,
    resetButton: false,
    title:t("providerManagementDetails.popups.new.title"),
    type:PopupType.providerProviderWorkerEditPopup
  });
}

const addOrUpdateCompanyWorker = async () => {
  const companyWorker = systemStore.modal.contentObject as ProviderWorker;

  const companyWorkerResponse = await providerWorkerService.addOrUpdateProviderWorker(selectedProvider.value?.id!, companyWorker, ErrorLocationType.popup);
  if(!companyWorkerResponse) return

  if(companyWorker.id === "") {
    companyWorker.id = companyWorkerResponse.userId;
    companyWorker.userId = companyWorkerResponse.userId;
  }
  // fix selection when it was an update -> replace old value in selected-array
  else if(selectedProviderWorkers.value.some(el => el.id === companyWorker.id)) {
    selectedProviderWorkers.value = selectedProviderWorkers.value.filter(el => el.id !== companyWorker.id);
    selectedProviderWorkers.value.push(companyWorker);
  }

  gridStore.add(companyWorker);
  await gridStore.sort(gridStore.sorters);

  systemStore.closeModal();
  systemStore.showSuccess(t('global.saved'));
}

const setGridData = async ()=>{
  // start spinner
  systemStore.gridDataIsLoading = true;

  const companyWorkerResp = await providerWorkerService.getProviderWorkersForProvider(selectedProvider.value?.id!, ErrorLocationType.table);
  if(!companyWorkerResp) return

  //@ts-expect-error
  gridStore.setStoreData(companyWorkerResp.companyWorkers.map(cw =>{
    cw.id = cw.userId;
    return cw;
  }));

  //@ts-expect-error
  selectedProvider.value.hasAdmin = companyWorkerResp.companyWorkers.some((cw:any) => cw.isAdmin);

  systemStore.reorderColumns(TableType[TableType.providerWorkers]);

  // stop spinner
  systemStore.gridDataIsLoading = false;
};


onMounted(async () => {
  // start spinner
  systemStore.gridDataIsLoading = true;
  const selectedCompanyResp = await providerService.getProviderById(router.currentRoute.value.params.id as string, ErrorLocationType.table);

  //@ts-expect-error
  selectedProvider.value = selectedCompanyResp.companyInfo;

  //@ts-expect-error
  companyHasAdmin.value = selectedProvider.value?.hasAdmin;
  // stop spinner
  systemStore.gridDataIsLoading = false;

  // calculate grid height and sub to window resize event
  recalcGridHeight();
  window.addEventListener('resize', recalcGridHeight);

  systemStore.setGridStore(ref(gridStore));
  systemStore.setGridColumnStore(ref(grid.value?.instance.value?.columns));

  await setGridData();
});

onBeforeUnmount(()=>{
  window.removeEventListener('resize', recalcGridHeight);

  systemStore.setGridStore(null);
  systemStore.setGridColumnStore(null);

  systemStore.currentItems = 0;
  systemStore.allItems = 0;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h4", null, _toDisplayString(_ctx.$t("providerManagementDetails.title")), 1)
    ]),
    (selectedProvider.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(router).back && _unref(router).back(...args)))
            }, [
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("div", null, _toDisplayString(_ctx.$t("general.back")), 1)
              ])
            ]),
            _createElementVNode("h4", _hoisted_6, _toDisplayString(_ctx.$t("providerManagementDetails.headline")) + " " + _toDisplayString(selectedProvider.value.name), 1)
          ]),
          _createElementVNode("div", {
            class: "providerDetails",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_isRef(showProviderDetails) //@ts-ignore
 ? showProviderDetails.value = !_unref(showProviderDetails) : showProviderDetails = !_unref(showProviderDetails)))
          }, [
            (_unref(showProviderDetails))
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t("providerManagementDetails.address")), 1),
                      _hoisted_10,
                      _createTextVNode(" " + _toDisplayString(selectedProvider.value.street) + " " + _toDisplayString(selectedProvider.value.streetnumber), 1),
                      _hoisted_11,
                      _createTextVNode(" " + _toDisplayString(selectedProvider.value.zip) + " " + _toDisplayString(selectedProvider.value.city), 1)
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t("providerManagementDetails.contact")), 1),
                      _hoisted_13,
                      _createTextVNode(" " + _toDisplayString(selectedProvider.value.contactPersonName), 1),
                      _hoisted_14,
                      _createTextVNode(" " + _toDisplayString(selectedProvider.value.contactPersonPhoneNumber), 1),
                      _hoisted_15,
                      _createElementVNode("a", {
                        href: 'mailto:'+selectedProvider.value.contactPersonEmail
                      }, _toDisplayString(selectedProvider.value.contactPersonEmail), 9, _hoisted_16)
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t("providerManagementDetails.information")), 1),
                      _hoisted_18,
                      _createTextVNode(" " + _toDisplayString(selectedProvider.value.info), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createTextVNode(_toDisplayString(_ctx.$t("providerManagementDetails.lessInfos")) + " ", 1),
                    _hoisted_20
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createTextVNode(_toDisplayString(_ctx.$t("providerManagementDetails.moreInfos")) + " ", 1),
                    _hoisted_23
                  ])
                ]))
          ]),
          _withDirectives(_createElementVNode("div", null, [
            _createVNode(Error, {
              errorLoc: _unref(ErrorLocationType).table
            }, null, 8, ["errorLoc"]),
            (companyHasAdmin.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('providerManagementDetails.hasAdmin')), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("button", {
                  class: "primary mr-2",
                  disabled: companyHasAdmin.value,
                  onClick: newCompanyWorker,
                  title: _unref(t)('providerManagementDetails.new'),
                  id: "createNew"
                }, _hoisted_29, 8, _hoisted_27),
                _createElementVNode("button", {
                  class: "primary mr-2",
                  disabled: !_unref(selectedProviderWorkers).some(()=>true),
                  onClick: deleteSelection,
                  title: _unref(t)('global.delete'),
                  id: "deleteSelection"
                }, _hoisted_32, 8, _hoisted_30),
                _createElementVNode("div", _hoisted_33, [
                  _createVNode(GridInputFilter, {
                    gridStore: _unref(gridStore),
                    hideFilterButton: true
                  }, null, 8, ["gridStore"])
                ])
              ]),
              _createVNode(_unref(BryntumGrid), _mergeProps({
                ref_key: "grid",
                ref: grid
              }, gridConfig, { readOnly: true }), null, 16)
            ])
          ], 512), [
            [_vShow, !_unref(systemStore).gridDataIsLoading]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_34, [
            _createVNode(LoadingSpinner)
          ], 512), [
            [_vShow, _unref(systemStore).gridDataIsLoading]
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})